import * as React from "react";
import { useEffect, useState } from "react";
import Backdrop from "@mui/material/Backdrop";
import Box from "@mui/material/Box";
import Fade from "@mui/material/Fade";
import CircularProgress from "@mui/material/CircularProgress";
import { Modal } from "@mui/material";
import axiosInstance from "../../axiosInstance";

const DEFAULT_IFRAME_BASE =
  "https://management.londonist.co.uk/cancellation-process-of-student";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  maxWidth: "1200px",
  width: "90%",
  height: "90vh",
  bgcolor: "background.paper",
  borderRadius: "1rem",
  outline: "none",
  boxShadow: 24,
  p: 0,
};

function buildCancellationIframeSrc(baseUrl, invoiceId, studentId) {
  const url = new URL(baseUrl);
  url.searchParams.set("invoice_id", String(invoiceId ?? ""));
  url.searchParams.set("student_id", String(studentId ?? ""));
  url.searchParams.set("source", "partner_portal");
  return url.toString();
}

export default function CancellationFormModal({
  setOpen,
  open,
  invoiceId,
  studentId,
}) {
  const [iframeSrc, setIframeSrc] = useState(null);

  const handleCloseCancellationFormModal = () => setOpen(false);

  useEffect(() => {
    if (!open) {
      setIframeSrc(null);
      return;
    }

    let cancelled = false;
    setIframeSrc(null);

    const fallback = buildCancellationIframeSrc(
      DEFAULT_IFRAME_BASE,
      invoiceId,
      studentId
    );

    const accessToken = localStorage.getItem("accessToken");
    const token = localStorage.getItem("loginUser");

    axiosInstance
      .get(`${process.env.REACT_APP_BASE_URL}cancellation-v2`, {
        params: { invoice_id: invoiceId },
        headers: {
          Authorization: `Bearer ${accessToken}`,
          XRefreshToken: `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then((res) => {
        if (cancelled) {
          return;
        }
        const data = res?.data?.data;
        const baseUrl =
          data?.enabled && data?.iframe_url
            ? data.iframe_url
            : DEFAULT_IFRAME_BASE;
        setIframeSrc(
          buildCancellationIframeSrc(baseUrl, invoiceId, studentId)
        );
      })
      .catch(() => {
        if (!cancelled) {
          setIframeSrc(fallback);
        }
      });

    return () => {
      cancelled = true;
    };
  }, [open, invoiceId, studentId]);

  return (
    <div>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={open}
        onClose={handleCloseCancellationFormModal}
        closeAfterTransition
        slots={{ backdrop: Backdrop }}
        slotProps={{
          backdrop: {
            timeout: 500,
          },
        }}
      >
        <Fade in={open}>
          <Box sx={style}>
            <Box
              id="transition-modal-description"
              sx={{
                height: "calc(100% - 128px)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              {iframeSrc ? (
                <iframe
                  title="Cancellation process"
                  style={{ border: "none" }}
                  src={iframeSrc}
                  height={"100%"}
                  width={"100%"}
                />
              ) : (
                <CircularProgress />
              )}
            </Box>
          </Box>
        </Fade>
      </Modal>
    </div>
  );
}
